import type { OperationalQuotasProps } from 'operationalQuotas/OperationalQuotas';

export enum OperationalQuotasEvents {
    SHOW_MODAL = 'operationalQuotas/show',
    HIDE_MODAL = 'operationalQuotas/hide',
}

export type OperationalQuotasModalOptions = Partial<OperationalQuotasProps> & {
    surveyId: OperationalQuotasProps['surveyId'];
};

export function showOperationalQuotasModal(options: OperationalQuotasProps) {
    const event = new CustomEvent<OperationalQuotasModalOptions>(OperationalQuotasEvents.SHOW_MODAL, {
        detail: options,
    });
    window.dispatchEvent(event);
}

export function hideOperationalQuotasModal() {
    window.dispatchEvent(new CustomEvent(OperationalQuotasEvents.HIDE_MODAL));
}
